export const calendarDot = ["#0388D2", "#EF6C00", "#6A9F39", "#AA47BD"];
